import { CommonStylesDefaultValues } from 'cms/cms-shared/common-settings-styles/common-settings-styles.models';
import { CommonStylesImageValues } from 'cms/cms-shared/common-settings-styles/image/common-settings-styles-image.models';
import { IdtComponentCmsDefinition, CmsComponentGroups } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { TextPaddingDefaultSettings } from 'extensions/core/piece-text/front/models/piece-text.models';

import { PieceProductCarouselSettings } from './models/piece-product-carousel.model';


export const PieceProductCarouselDefinition: IdtComponentDefinition = {
  id: 'piece-product-carousel',
  role: IdtComponentRole.Piece,
  numSlots: 0
};

export const PRODUCT_CAROUSEL_DEFAULT_NUMBER_COLUMNS = 5;
export const PRODUCT_CAROUSEL_DEFAULT_NUMBER_ROWS = 1;


export const PRODUCT_CAROUSEL_DEFAULT_PRODUCT_NAME_FORMAT = '<p><span data-entity="placeholder">{{productName}}</span></p>';


export const PieceProductCarouselCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Carrusel de productos',
  group: CmsComponentGroups.Carousels,
  availablePlatforms: ['web', 'apps'],
  initialSettings: (): PieceProductCarouselSettings => {
    return {
      general: {
        sourceType: 'category',
        sourceId: undefined,
        numberOfColumns: PRODUCT_CAROUSEL_DEFAULT_NUMBER_COLUMNS,
        numberOfColumnsMobile: PRODUCT_CAROUSEL_DEFAULT_NUMBER_COLUMNS,
        numberOfRows: PRODUCT_CAROUSEL_DEFAULT_NUMBER_ROWS,
        numberOfRowsMobile: PRODUCT_CAROUSEL_DEFAULT_NUMBER_ROWS,
        maxProducts: 10,
        filterDuplicates: false,
        imageLocation: 'category_page',
        customImageLocation: undefined,
        enableUnifiedUrl: false,

        // Editor
        productNamesTextFormat: undefined,
        productPricesTextFormat: undefined,
        oldProductPricesTextFormat: undefined,
        priceDiscountTextFormat: undefined,
        futureProductPricesTextFormat: undefined,
        productPrewarmingDescriptionTextFormat: undefined,
        productPrewarmingDiscountRateTextFormat: undefined,
        prewarmingDiscountOption: 'old-price',
        priceDiscountOption: 'old-price',
        // Carousel flags
        showTitle: false,
        allowSlider: true,
        displayComponentArrows: false,
        displayComponentPager: false,
        loop: false,

        // Product flags
        displayProductNames: false,
        displayProductPrices: false,
        displayOriginalProductPrice: false,
        displayProductPriceDescription: false,
        displayOldProductPrices: false,
        displayFutureProductPrices: false,
        displayProductPrewarmingDescription: false,
        displayProductPrewarmingDiscountRate: false,
        hidePrewarmingWhenDiscountApplied: false,
        displayPriceDiscount: false,
        displayProductAddToCart: false, // TODO: Remove this property in the future
        displayProductTextAddToCart: false, // TODO: Remove this property in the future
        displayProductAddToCartToggle: false,
        displayProductIconAddToCart: false,
        displayButtonLink: false,
        displayProductMultiplePricesTwoLines: false,
        displayProductSizesSelector: false,
        displayProductSizesAdditionalInfo: false,
        displayLastSizeUnitsWarning: false,
        displayViewSimilar: false,
        displayColors: false,
        ...TextPaddingDefaultSettings
      },
      styles: {
        ...CommonStylesDefaultValues,
        ...CommonStylesImageValues,

        paddingTop: '0pt',
        paddingBottom: '0pt',
        paddingLeft: '0pt',
        paddingRight: '0pt',

        imageBorderRadiusType: 'straight',
        imageBorderRadius: '0pt',
        spaceBetweenProducts: '6px',
        initialOffset: '0px',
        finalOffset: '0px'
      },
      accessibility: {
        titleText: undefined,
        nextText: undefined,
        previousText: undefined
      }
    };
  }
};
